/**
 * Venus Jewelry — Popup de intención (pregunta → correo → código de descuento).
 * Markup: sections/vj-intent-popup.liquid · Estilos: assets/vj-intent-popup.css
 *
 * - Si responde (envía el contacto): no vuelve a aparecer nunca.
 * - Si lo cierra sin responder: no vuelve a aparecer en `data-dismiss-days` días.
 * - Al enviar: muestra el código, lo deja aplicado en el carrito y hace POST a
 *   `data-endpoint` (si está configurado).
 *   El código se muestra aunque el POST falle.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'vj-intent-popup';
  var DAY_MS = 24 * 60 * 60 * 1000;

  var dialog = document.getElementById('vjIntentPopup');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  var endpoint = dialog.dataset.endpoint || '';
  var delay = parseInt(dialog.dataset.delay, 10) || 0;
  var dismissDays = parseInt(dialog.dataset.dismissDays, 10) || 7;

  // En el editor de temas no lo mostramos solo (se vería en cada recarga).
  if (dialog.dataset.designMode === 'true') return;

  /* ── localStorage con expiración ─────────────────────────────── */

  function readState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var state = JSON.parse(raw);
      if (state.expires && state.expires < Date.now()) {
        localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return state;
    } catch (e) {
      return null;
    }
  }

  function writeState(status) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          status: status,
          expires: status === 'dismissed' ? Date.now() + dismissDays * DAY_MS : null,
        })
      );
    } catch (e) {
      /* localStorage bloqueado (modo privado): simplemente no se recuerda */
    }
  }

  if (readState()) return;

  /* ── Estado interno ──────────────────────────────────────────── */

  var answer = '';
  var answerKey = '';
  var submitted = false;

  var steps = dialog.querySelectorAll('[data-vj-ip-step]');
  var form = dialog.querySelector('form');
  var input = form.querySelector('input[name="contact"]');
  var errorEl = dialog.querySelector('[data-vj-ip-error]');
  var submitBtn = form.querySelector('.vj-ip__submit');

  function showStep(n) {
    steps.forEach(function (step) {
      step.hidden = step.dataset.vjIpStep !== String(n);
    });
    if (n === 2) {
      focusInput();
      return;
    }
    var focusTarget = dialog.querySelector('[data-vj-ip-step="' + n + '"] button:not([hidden])');
    if (focusTarget) focusTarget.focus({ preventScroll: true });
  }

  // En móvil (puntero táctil) no se enfoca el campo solo: hacerlo abre el teclado de golpe.
  // El cliente toca el campo cuando quiera escribir.
  var isTouch = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

  function focusInput() {
    if (!isTouch) input.focus({ preventScroll: true });
  }

  /* ── Sin zoom al enfocar el campo (iOS) ──────────────────────── */

  // Mientras el popup está abierto se fija la escala del viewport; al cerrarlo se restaura.
  var viewportMeta = document.querySelector('meta[name="viewport"]');
  var originalViewport = viewportMeta ? viewportMeta.getAttribute('content') : null;

  function lockZoom() {
    if (viewportMeta && originalViewport) {
      viewportMeta.setAttribute('content', originalViewport + ',maximum-scale=1');
    }
  }

  function unlockZoom() {
    if (viewportMeta && originalViewport) {
      viewportMeta.setAttribute('content', originalViewport);
    }
  }

  /* ── Validación ──────────────────────────────────────────────── */

  function getContact() {
    var value = input.value.trim();
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value) ? value : null;
  }

  /* ── Envío al endpoint ───────────────────────────────────────── */

  function postLead(payload) {
    if (!endpoint) return Promise.resolve();
    var body = JSON.stringify(payload);

    return fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body,
      keepalive: true,
    }).catch(function () {
      // Reintento sin preflight CORS (text/plain) por si el endpoint no lo permite.
      try {
        navigator.sendBeacon(endpoint, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
      } catch (e) {
        /* sin más opciones: el cliente igual ve su código */
      }
    });
  }

  /* ── Aplicar el código al carrito ────────────────────────────── */

  // /discount/CODIGO deja el código en la cookie `discount_code` (Shopify lo aplica
  // solo en el checkout) y venus-newsletter-discount.js lo pone en el carrito en
  // cuanto existe — ahora mismo si ya hay productos, o al agregar el primero.
  function applyDiscount(code) {
    if (!code) return;
    fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
      .then(function () {
        if (typeof window.vjApplyCookieDiscount === 'function') window.vjApplyCookieDiscount();
      })
      .catch(function () {
        /* sin red: el cliente igual tiene el código a la vista para copiarlo */
      });
  }

  /* ── Eventos ─────────────────────────────────────────────────── */

  dialog.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    // Clic en el fondo (fuera del panel)
    if (target === dialog) {
      dialog.close();
      return;
    }

    if (target.closest('[data-vj-ip-close]')) {
      dialog.close();
      return;
    }

    var option = target.closest('[data-vj-ip-option]');
    if (option) {
      answer = option.dataset.vjIpOption;
      answerKey = option.dataset.vjIpKey || '';
      showStep(2);
      return;
    }

    if (target.closest('[data-vj-ip-copy]')) {
      var code = dialog.dataset.discountCode;
      var button = target.closest('[data-vj-ip-copy]');
      var done = function () {
        button.textContent = 'Copiado';
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () {});
      }
    }
  });

  form.addEventListener('submit', function (event) {
    event.preventDefault();
    var contact = getContact();

    if (!contact) {
      errorEl.textContent = 'Escribe un correo válido.';
      errorEl.hidden = false;
      input.focus();
      return;
    }

    errorEl.hidden = true;
    submitBtn.disabled = true;
    submitted = true;
    writeState('answered');

    postLead({
      answer: answer,
      answer_key: answerKey,
      contact: contact,
      contact_type: 'email',
      timestamp: new Date().toISOString(),
      page_url: window.location.href,
    });

    applyDiscount(dialog.dataset.discountCode);
    showStep(3);
  });

  // Cierre sin responder (X, "No, gracias", Esc o clic fuera): no volver en N días.
  dialog.addEventListener('close', function () {
    unlockZoom();
    if (!submitted) writeState('dismissed');
  });

  setTimeout(function () {
    // No interrumpir si el visitante ya abrió el carrito u otro diálogo.
    if (document.querySelector('dialog[open]')) return;
    lockZoom();
    dialog.showModal();
  }, delay * 1000);
})();
